// extracted by mini-css-extract-plugin
module.exports = {"controlsWrapper":"ContentFooter_controlsWrapper__2sNgN"};